import { useQuery } from '@tanstack/react-query';

import { getDatasets } from '~/api/experiments';

function parsePipelineVersion(version: string): number {
  const parsed = Number.parseFloat(version);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

type AgentLogDatasetsQueryKeyParams = {
  realm: string;
  pipelineName: string;
  version: number;
  connectorId: string;
};

export const agentLogDatasetsQueryKey = (
  params: AgentLogDatasetsQueryKeyParams
) => ['agent-logs', 'datasets', params] as const;

type UseAgentLogDatasetsParams = {
  realm: string;
  pipelineName: string;
  pipelineVersion: string;
  connectorId: string;
  enabled?: boolean;
};

export function useAgentLogDatasets({
  realm,
  pipelineName,
  pipelineVersion,
  connectorId,
  enabled = true
}: UseAgentLogDatasetsParams) {
  const version = parsePipelineVersion(pipelineVersion);

  return useQuery({
    queryKey: agentLogDatasetsQueryKey({
      realm,
      pipelineName,
      version,
      connectorId
    }),
    queryFn: () => getDatasets(realm, pipelineName, version, connectorId),
    enabled:
      enabled && !!realm && !!pipelineName && !!connectorId && version > 0,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false
  });
}
